<template>
  <div class="navigation">
    <div class="navigation-content">
      <img src="../assets/img/logo.png" alt=""><span class="com-name">山湖测绘</span>
      <div class="navigation-content-ul">
        <div class="navigation-content-ul-li" v-for="(item,i) in routeArr" :key="i" :class="{'active':currentId===item.id}">
          <router-link :to="item.to">{{item.name}}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      currentId:'',
      routeArr:[
        {
          name:"首页",
          id:"home",
          to:"/home"
        },
        {
          name:"产品服务",
          id:"service",
          to:"/service"
        },
        {
          name:"项目案例",
          id:"project",
          to:"/project"
        },
        {
          name:"新闻中心",
          id:"news",
          to:"/news"
        },
        {
          name:"关于我们",
          id:"about",
          to:"/about"
        },
        {
          name:"联系我们",
          id:"contact",
          to:"/contact"
        }
      ]
    }
  },
  watch: {
    $route:{
      handler(val){
        this.currentId = val.name
        console.log(val,this.currentId)
      },
      immediate:true
    },
  }
};
</script>
<style lang="scss" scoped>
  .navigation{
    width:100%;
    height:100%;
    display: flex;
    justify-content: center;
    align-items: center;
    &-content{
      width:12rem;
      height:100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      img{
        width:0.61rem;
        height:0.44rem;
      }
      .com-name{
        width:1.5rem;
        margin-left:0.08rem;
        font-size:0.24rem;
        color:#000;
        font-family: pfmediumfont;
        display: flex;
        justify-content: flex-start;
      }
      &-ul{
        width:100%;
        height:100%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        &-li{
          display: flex;
          justify-content: center;
          align-items: center;
          height:100%;
          margin-right:0.3rem;
          a{
            text-decoration: none;
            font-size: 16px;
            font-family: pfmediumfont;
            color: #333333;
            font-weight:500;
          }
        }
        :last-child{
          margin-right: 0;
        }
        &-li.active{
          a{
            color: #ffbe00;
          }
        }
      }
    }
  }
</style>
